import { render, staticRenderFns } from "./CreateEditRetentionPolicy.vue?vue&type=template&id=6c3d02cc&"
import script from "./CreateEditRetentionPolicy.vue?vue&type=script&lang=js&"
export * from "./CreateEditRetentionPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports